import { c as _c } from "react/compiler-runtime";
import FunnelEmailCreate from 'modules/funnels/funnel/components/email-tab/funnel-email-create';
import FunnelEmailTable from 'modules/funnels/funnel/components/email-tab/funnel-email-table';
import FunnelEmailUpdate from 'modules/funnels/funnel/components/email-tab/funnel-email-update';
import { useFunnelEmails } from 'modules/funnels/funnel/components/email-tab/hooks/use-funnel-emails';
import { FunnelEmailsInterface } from 'modules/funnels/funnel/components/email-tab/types/funnel-emails-interface';
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface';
import { useState } from 'react';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
interface FunnelEmailTabProps {
  funnelStepId?: FunnelStepId;
}
function EmailTab(t0) {
  const $ = _c(22);
  const {
    funnelStepId
  } = t0;
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  const [emailForm, setEmailForm] = useState();
  let t1;
  if ($[0] !== funnelStepId || $[1] !== limit || $[2] !== pagination) {
    t1 = {
      limit,
      pagination,
      funnelStepId
    };
    $[0] = funnelStepId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: emails,
    mutate: mutateEmails
  } = useFunnelEmails(t1);
  if (emailForm === "create") {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = () => setEmailForm(undefined);
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== emails || $[6] !== funnelStepId || $[7] !== setPagination) {
      t3 = <FunnelEmailCreate funnelStepId={funnelStepId} emails={emails} setPagination={setPagination} onBack={t2} />;
      $[5] = emails;
      $[6] = funnelStepId;
      $[7] = setPagination;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  if (emailForm) {
    let t2;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = () => setEmailForm(undefined);
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[10] !== emailForm || $[11] !== funnelStepId || $[12] !== mutateEmails) {
      t3 = <FunnelEmailUpdate instance={emailForm} funnelStepId={funnelStepId} mutateEmails={mutateEmails} onBack={t2} />;
      $[10] = emailForm;
      $[11] = funnelStepId;
      $[12] = mutateEmails;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    return t3;
  }
  let t2;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setEmailForm("create");
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== emails || $[16] !== funnelStepId || $[17] !== limit || $[18] !== pagination || $[19] !== setLimit || $[20] !== setPagination) {
    t3 = <FunnelEmailTable emails={emails} funnelStepId={funnelStepId} limit={limit} setLimit={setLimit} setPagination={setPagination} pagination={pagination} onCreate={t2} onEdit={setEmailForm} />;
    $[15] = emails;
    $[16] = funnelStepId;
    $[17] = limit;
    $[18] = pagination;
    $[19] = setLimit;
    $[20] = setPagination;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  return t3;
}
export default EmailTab;